import React, { useEffect, useContext } from 'react';
import { Logger, Hub } from 'aws-amplify';
import { Link, Route, Switch } from 'react-router-dom';

import * as Routes from '../routes';
import * as Screens from '../screens';
import { Bar, General } from '../components';
import { Container } from 'react-bootstrap'

const MainSwitch = (props) => {
	const { children, authState } = props;

	
		return (
			<>
					<Switch>
						<Route exact path="/" component={Routes.Home.Main} />
						<Route exact path="/privacy" component={Routes.Home.Privacy} />
						<Route exact path="/terms" component={Routes.Home.Terms} />
						<Route exact path="/gdpr" component={Routes.Home.GDPR} />
					</Switch>
				<Bar.CopyrighStamp />
			</>
		);
	
};

export default MainSwitch;
